<template>
  <footer>
    <div class="footer-content">
      <div class="container">
        <div class="row">
          <div class="col-20 col-lg-6 order-2 order-lg-1 text-lg-left">
            <div class="col-title">
              {{ $t('layout-footer.col1.title') }}
            </div>
            <div
              class="col-content"
              v-html="$t('layout-footer.col1.content')"
            />
          </div>
          <div class="col-20 col-lg-8 order-1 order-lg-2 text-center">
            <img :src="$publicPath + 'img/logo-white.svg'"><br>
            <div class="social">
              <a
                v-if="$t('layout-footer.social.link.facebook').length > 0"
                :href="$t('layout-footer.social.link.facebook')"
                target="_blank"
                class="social-ball facebook"
              >
                <img :src="$publicPath + 'img/social/facebook-white.svg'">
              </a>
              <a
                v-if="$t('layout-footer.social.link.instagram').length > 0"
                :href="$t('layout-footer.social.link.instagram')"
                target="_blank"
                class="social-ball instagram"
              >
                <img :src="$publicPath + 'img/social/instagram-white.svg'">
              </a>
              <a
                v-if="$t('layout-footer.social.link.twitter').length > 0"
                :href="$t('layout-footer.social.link.twitter')"
                target="_blank"
                class="social-ball twitter"
              >
                <img :src="$publicPath + 'img/social/twitter-white.svg'">
              </a>
              <a
                v-if="$t('layout-footer.social.link.youtube').length > 0"
                :href="$t('layout-footer.social.link.youtube')"
                target="_blank"
                class="social-ball youtube"
              >
                <img :src="$publicPath + 'img/social/youtube-white.svg'">
              </a>
              <a
                v-if="$t('layout-footer.social.link.linkedin').length > 0"
                :href="$t('layout-footer.social.link.linkedin')"
                target="_blank"
                class="social-ball linkedin"
              >
                <img :src="$publicPath + 'img/social/linkedin-white.svg'">
              </a>
            </div>
          </div>
          <div class="col-20 col-lg-6 order-3 text-lg-right">
            <div class="d-inline-block text-lg-left">
              <div class="col-title">
                {{ $t('layout-footer.col2.title') }}
              </div>
              <div class="col-content">
                <router-link :to="{name: 'site', params: { url: 'regulations' }}">
                  {{ $t('navigation.link-name.site.regulations') }}
                </router-link><br>
                <router-link :to="{name: 'site', params: { url: 'privacy-policy' }}">
                  {{ $t('navigation.link-name.site.privacy-policy') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      {{ $t('layout-footer.copyright.part1') }} {{ (new Date()).getFullYear() }} {{ $t('layout-footer.copyright.part2') }}
    </div>
  </footer>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  footer {
    width: 100%;
    margin-top:auto;
    .footer-content {
      padding: 2.5rem;
      background-color: black;
      color: white;
    }
    .copyright {
      background-color: $warning;
      text-align: center;
      font-size: 0.8125rem;
      padding: 0.75rem;
    }
  }
  .col-title {
    font-size: 0.688rem;
    font-weight: bold;
    margin-bottom: 1.2rem;
  }
  .col-content {
    font-size: 0.875rem;
    font-weight: 400;
    a {
      color: inherit;
      font-weight: inherit;
    }
  }
  .social {
    margin-top: 1.5rem;
    width: 190px;
    display: inline-flex;
    justify-content: center;
    .social-ball {
      transition: .2s;
      width: 20px;
      height: 20px;
      cursor: pointer;
      margin-left: 0.3rem;
      margin-right: 0.3rem;
      img {
        max-width: 10px;
      }
      &:hover {
        transform: scale(1.2);
      }
    }
  }
  .col-20 {
    text-align: center;
    @include media-breakpoint-down(md) {
      .col-title {
        margin-top: 2rem;
      }
      .social {
        margin-left: auto;
        margin-right: auto;
        max-width: 100%;
      }
    }
  }
</style>
